var _linearGradient, _linearGradient2, _g, _animateTransform;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    "view-box": "0 0 80 80",
    color: "#f1f1f1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "spinnerSecondHalf"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 0,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.5,
    stopColor: "currentColor"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "spinnerFirstHalf"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.5,
    stopColor: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#spinnerSecondHalf)",
    d: "M 3 40 A 3 3 0 0 1 77 40"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#spinnerFirstHalf)",
    d: "M 77 40 A 3 3 0 0 1 3 40"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M 3 40 A 3 3 0 0 1 3 40"
  }))), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    from: "0 0 0",
    to: "360 0 0",
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "2000ms"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.b906b671bfba704c3ed10a15689f0821.svg";
export { ForwardRef as ReactComponent };